import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appRevealToggle]'
})
export class RevealToggleDirective {

  @Input() set appRevealToggle(val: string) {
    if (val === 'open') {
      this._revealContainer.classList.add('is-open');
    } else if (val === 'closed') {
      this._revealContainer.classList.remove('is-open');
    }
  }

  private _revealContainer = null;

  constructor(private ele: ElementRef) {
    this.ele.nativeElement.setAttribute('tabindex', '0');

    let currentParent = this.ele.nativeElement.parentNode;

    while (this._revealContainer === null) {
      if (currentParent.classList.contains('reveal')) {
        this._revealContainer = currentParent;
      } else {
        currentParent = currentParent.parentNode;
      }
    }
  }

  @HostListener('click', ['$event'])
  toggleClassFromClick(event) {
    this._revealContainer.classList.toggle('is-open');
  };

  @HostListener('keyup', ['$event'])
  toggleClassFromKey(event) {
    if (event.keyCode === 13 ) {
      this._revealContainer.classList.toggle('is-open');
    }
  };

}
